'use strict';

function INVITE_STATUS() {
  Object.defineProperties(this, {
    ERROR_BLACKLIST: {enumerable: true, value: 'error_blacklist'},
    ERROR_FAILED_TO_DELIVER: {enumerable: true, value: 'error_failed_to_deliver'},
    PENDING: {enumerable: true, value: 'pending'},
    EMAIL_SENT: {enumerable: true, value: 'email_sent'},
    CANCELLED: {enumerable: true, value: 'cancelled'},
    REJECTED: {enumerable: true, value: 'rejected'},
    ACCEPTED: {enumerable: true, value: 'accepted'},
  });
}

INVITE_STATUS.prototype.toList = function toList() {
  return ['pending', 'cancelled', 'rejected', 'accepted'];
};

INVITE_STATUS.prototype.complete = function complete(status) {
  switch (status) {
    case 'cancelled':
    case 'rejected':
    case 'accepted':
      return true;
    default:
      return false;
  }
};

module.exports = new INVITE_STATUS();



// WEBPACK FOOTER //
// ./src/js/organizations/enums/INVITE_STATUS.js